import { render, staticRenderFns } from "./TabsWithTable.vue?vue&type=template&id=a7e62650&scoped=true&"
import script from "./TabsWithTable.vue?vue&type=script&lang=ts&"
export * from "./TabsWithTable.vue?vue&type=script&lang=ts&"
import style0 from "./TabsWithTable.vue?vue&type=style&index=0&id=a7e62650&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e62650",
  null
  
)

export default component.exports